import { useTranslation } from "react-i18next";
import { BiCheck, BiChevronLeft } from "react-icons/bi";
import Header from "shared/components/Header";
import { NAME_SPACES } from "shared/locales/constants";
import StaticDocumentFields from "../../shared/StaticDocumentFields";
import useStaticDocumentForm from "../../shared/useStaticDocumentForm";

const View = ({ document, onSubmit, cancel, onDownload, loading }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS);
  const FORM = t("STATIC.FORM", { returnObjects: true });
  const form = useStaticDocumentForm({ document, fileRequired: false });

  return (
    <>
      <Header
        title={FORM.EDIT_TITLE}
        subtitle={document.name}
        actions={[
          {
            text: FORM.BACK,
            onClick: cancel,
            type: "primary--outlined",
            icon: <BiChevronLeft size={20} />,
          },
          {
            text: FORM.SAVE,
            onClick: () => onSubmit(form.data()),
            type: "primary",
            icon: <BiCheck size={20} />,
            disabled: !form.isValid || loading,
            loading,
          },
        ]}
      />
      <StaticDocumentFields
        form={form}
        document={document}
        onDownload={onDownload}
      />
    </>
  );
};

export default View;
